<div class="fieldset title-area ">
  <legend>WorkBuddy</legend>
</div>

<div class="fieldset content-area">
  <div class="description description-title">Thank you for using WorkBuddy.</div>
  <div class="description">This account has been deleted and is no longer accessible.</div>
</div>